import React from 'react';
import { Box, Grid, Text } from '@chakra-ui/react';
import { motion, useReducedMotion } from 'framer-motion';

const MotionBox = motion(Box);

function Manifesto() {
  const shouldReduce = useReducedMotion();
  const ease = [0.25, 0.1, 0.25, 1];

  return (
    <Box as="section" id="manifesto" aria-label="Company philosophy"
      bg="oid.bg" py={{ base: '55px', md: '89px' }}>
      <Grid templateColumns={{ base: '1fr', md: '38.2% 1fr' }}
        gap={{ base: 12, lg: 20 }} alignItems="start"
        maxWidth="1600px" mx="auto" px={{ base: 6, lg: 12 }}>

        <MotionBox
          initial={shouldReduce ? false : { opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-80px' }}
          transition={{ duration: 0.7, ease }}>
          <Box mb={6}>
            <Box as="span" display="block" width="24px" height="2px"
              bg="oid.accent" mb={4} aria-hidden="true" />
            <Text fontSize="11px" fontWeight={600} letterSpacing="0.3em"
              textTransform="uppercase" color="oid.accent">Philosophy</Text>
          </Box>
          <Text as="h2" sx={{ position: 'absolute', width: '1px', height: '1px',
            padding: 0, margin: '-1px', overflow: 'hidden',
            clip: 'rect(0,0,0,0)', whiteSpace: 'nowrap', borderWidth: 0 }}>
            Company Philosophy
          </Text>
          <Text fontSize="1rem" fontWeight={400} color="oid.muted"
            lineHeight={1.618} maxWidth="300px" mb={5}>
            Every design decision at O-ID originates from the same question: will this
            work when it has to? Not in a lab, but in the field, under pressure, when
            the cost of failure is real.
          </Text>
          <Text fontSize="1rem" fontWeight={400} color="oid.muted"
            lineHeight={1.618} maxWidth="300px">
            That constraint shapes everything: module interfaces, materials, tooling
            requirements, and the software stack that ties it all together.
          </Text>
        </MotionBox>

        <MotionBox
          initial={shouldReduce ? false : { opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-80px' }}
          transition={{ duration: 0.7, delay: 0.15, ease }}>
          <Box as="blockquote"
            borderLeft="3px solid" borderColor="oid.accent"
            pl={{ base: 6, md: 10 }} py={2}>
            <Text fontFamily="'Noto Serif JP', Georgia, serif"
              fontWeight={400} lineHeight={1.45} color="oid.text"
              sx={{ fontSize: 'clamp(24px, 3vw, 42px)' }}>
              "A machine is only as good as its ability to be repaired,
              reconfigured, and returned to work."
            </Text>
            <Text fontSize="11px" fontWeight={600} letterSpacing="0.22em"
              textTransform="uppercase" color="oid.muted" mt={8}>
              O-ID Design Principle 01
            </Text>
          </Box>
        </MotionBox>
      </Grid>
    </Box>
  );
}
export default Manifesto;
